module.exports = __webpack_public_path__ + "static/media/Fit3d-data.dd0149ec.png";